export default () => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lazyLoadVideo);
  } else {
    lazyLoadVideo();
  }
  
  function lazyLoadVideo() {
    const lazyVideos = document.querySelectorAll('video.lazy');
  
    if ('IntersectionObserver' in window) {
      const lazyVideoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const sources = entry.target.querySelectorAll('source');
            sources.forEach(source => source.src = source.dataset.src);
            entry.target.load();
            entry.target.classList.remove('lazy');
            entry.target.play().then(() => {}).catch(error => {
              entry.target.parentElement.classList.add('video__suspended');
            });
            lazyVideoObserver.unobserve(entry.target);
          }
        });
      });
      lazyVideos.forEach(video => lazyVideoObserver.observe(video));
    }
  }  
}